<section>
  <span class="d-block text-md mb-2">{{ 'wizards:entityWizards.company.destinationsStep.description' | i18next }}</span>

  <span class="d-block text-md mb-2">
    {{
      (ability.can('read', PermissionsEnum.Storage)
        ? 'wizards:entityWizards.company.destinationsStep.recommendation'
        : 'wizards:entityWizards.company.destinationsStep.selectExistingHint'
      ) | i18next
    }}
  </span>

  <span class="d-block text-md mb-3 fw-semibold">{{ 'wizards:entityWizards.company.destinationsStep.skipHint' | i18next }}</span>

  @if (ability.can('read', PermissionsEnum.Storage)) {
    <mbs-group-button>
      <mbs-button
        icon="ico ico-Plus"
        [id]="elementSelectors.id.addButton"
        [loading]="loading()"
        (click)="createDestinationClickHandler()">
        {{ 'wizards:entityWizards.company.destinationsStep.addButton' | i18next }}
      </mbs-button>

      <mbs-dropdown-button
        [disabled]="loading()"
        [dropdownTemplate]="addDestinationDropdown"
        [id]="elementSelectors.id.addDropdown"></mbs-dropdown-button>

      <ng-template #addDestinationDropdown>
        <button
          ngbDropdownItem
          type="button"
          (click)="createDestinationClickHandler()">
          {{ 'wizards:entityWizards.company.destinationsStep.createNew' | i18next }}
        </button>

        <button
          ngbDropdownItem
          type="button"
          (click)="selectExistingClickHandler()">
          {{ 'wizards:entityWizards.company.destinationsStep.selectExisting' | i18next }}
        </button>
      </ng-template>
    </mbs-group-button>
  } @else {
    <mbs-button
      [id]="elementSelectors.id.selectExistingButton"
      [loading]="loading()"
      (click)="selectExistingClickHandler()">
      {{ 'wizards:entityWizards.company.destinationsStep.selectExisting' | i18next }}
    </mbs-button>
  }

  @if (destinations().length) {
    <div class="border rounded mt-3">
      @for (destination of destinations(); track destination.bucketId) {
        <article
          class="p-3"
          [class.border-bottom]="!$last">
          <div class="d-flex align-items-center mb-2">
            <i class="flex-shrink-0 mr-2 mbs-storage mbs-storage-sm mbs-storage_{{ destination.storageAccountType | storageIcon }}"></i>
            <strong class="text-break">{{ destination.displayDestinationName }}</strong>
          </div>

          <dl class="row mb-0">
            <dt class="col-4 text-gray-600 fw-normal">
              {{ 'wizards:entityWizards.company.destinationsStep.storageAccountName' | i18next }}
            </dt>
            <dd class="col-8 mb-1 text-break">{{ destination.displayStorageName }}</dd>

            <dt class="col-4 text-gray-600 fw-normal">
              {{ 'wizards:entityWizards.company.destinationsStep.bucket' | i18next }}
            </dt>
            <dd class="col-8 mb-1 text-break">{{ destination.bucketName }}</dd>

            <dt class="col-4 text-gray-600 fw-normal">
              {{ 'wizards:entityWizards.company.destinationsStep.region' | i18next }}
            </dt>
            <dd class="col-8 mb-1">{{ destination.regionDisplayName || '-' }}</dd>

            <dt class="col-4 text-gray-600 fw-normal">
              {{ 'wizards:entityWizards.company.destinationsStep.storageLimit' | i18next }}
            </dt>
            <dd class="col-8 mb-0">{{ destination.storageLimitName || '-' }}</dd>
          </dl>
        </article>
      }
    </div>
  }
</section>
